import App from 'app/app.js';
import 'app/service/TranslateProviderService.js';
import 'app/store/UserProfileStore.js';
import 'app/store/ContentStore.js';

function LtEmailOptionDirective(TranslateProviderService, UserProfileStore, ContentStore) {
  return {
    restrict: 'E',
    scope: {
      emailOptions: '='
    },
    template:
      '<div class="row email-options">' +
      '<div class="col-xs-12">' +
      '<span lt-translate="EMAIL_OPTIONS_TITLE" class="title"></span>' +
      '<ul class="mailing-list">' +
      '<li class="clearfix" ng-class="{on: preschoolEmailOption}" ng-click="togglePreschoolEmailOption()">' +
      '<div class="checkbox"></div>' +
      '<div class="label" lt-translate="EMAIL_OPTIONS_PRESCHOOL"></div>' +
      '</li>' +
      '<li class="clearfix" ng-class="{on: underclassEmailOption}" ng-click="toggleUnderclassEmailOption()">' +
      '<div class="checkbox"></div>' +
      '<div class="label" lt-translate="EMAIL_OPTIONS_UNDERCLASS"></div>' +
      '</li>' +
      '</ul>' +
      '</div>' +
      '</div>',
    link: function (scope, element, attrs, enhancementsCtrl) {
      var UserSubscription = UserProfileStore.UserSubscription,
        init = function () {
          // get subscription status from user profile store
          if (!!UserProfileStore.userProfile.subscriptions) {
            scope.preschoolEmailOption = UserProfileStore.subscribeForPreschool();
            scope.underclassEmailOption = UserProfileStore.subscribeForUnderclass();
          } else {
            // set defaults
            scope.preschoolEmailOption = !TranslateProviderService.isCanadianDomain();
            scope.underclassEmailOption = !TranslateProviderService.isCanadianDomain();
          }

          scope.emailOptions = [];
          if (scope.preschoolEmailOption) {
            scope.emailOptions.push(UserSubscription.Preschool);
          }

          if (scope.underclassEmailOption) {
            scope.emailOptions.push(UserSubscription.Underclass);
          }
        };

      // initialize
      init();

      scope.togglePreschoolEmailOption = function () {
        scope.preschoolEmailOption = !scope.preschoolEmailOption;
        if (scope.preschoolEmailOption) {
          scope.emailOptions.push(UserSubscription.Preschool);
        } else {
          scope.emailOptions = R.filter(R.compose(R.not, R.eq(UserSubscription.Preschool)))(scope.emailOptions);
        }
      };

      scope.toggleUnderclassEmailOption = function () {
        scope.underclassEmailOption = !scope.underclassEmailOption;
        if (scope.underclassEmailOption) {
          scope.emailOptions.push(UserSubscription.Underclass);
        } else {
          scope.emailOptions = R.filter(R.compose(R.not, R.eq(UserSubscription.Underclass)))(scope.emailOptions);
        }
      };
    }
  };
}

App.directive('ltEmailOption', [
  'TranslateProviderService',
  'UserProfileStore',
  'ContentStore',
  LtEmailOptionDirective
]);
